import { generateSixesDemoCard } from "./sixesDemoCard";
import { buildSettledCellOutcomes, settledFooterStats } from "../lib/sixesBucketSlide";
import { sixesBucketColor } from "../lib/sixesMarketBucket";
import {
    markSixesCardRevealed,
    markSixesSimulationComplete,
} from "../lib/sixesCardRevealStorage";
import { writeSixesSeenSettlement } from "../lib/sixesSettlementSeenStorage";

/**
 * Persist a finished demo card so the lobby mini-grid and Open Card skip the live sim.
 * Used by the presenter Finish league control.
 */
export function persistSixesDemoMatchFinished(matchId: string): void {
    const id = String(matchId || "").trim();
    if (!id) return;
    markSixesCardRevealed(id);
    const card = generateSixesDemoCard(id);
    const outcomes = buildSettledCellOutcomes(card);
    const stats = settledFooterStats(card);
    writeSixesSeenSettlement(id, {
        v: 2,
        outcomes,
        celebratedLineKeys: [],
        celebratedBuckets: card.slideTargets.map((target) => target.bucket),
        footerStats: {
            wins: stats.wins,
            slides: stats.slides,
            natural: stats.natural,
            coins: stats.coins,
            multiplierSixes: 2,
        },
        cellColors: card.buckets.map((bucket) => sixesBucketColor(bucket)),
        buckets: card.buckets,
    });
    markSixesSimulationComplete(id);
}
